import { cva } from "class-variance-authority"

export const navigationLinkIcon = cva([
	"text-(--base-a11)",
	"group-hover:text-(--base-a12)",
	"group-data-[status=active]:text-(--base-a12)",
	"transition-[color]",
])

export const navigationLink = cva([
	"group",
	"flex",
	"items-center",
	"gap-2",
	"h-8",
	"w-full",
	"px-4",
	"transition-[background,color]",
	"text-base",
	"text-(--base-a11)",

	// Focus
	"focus-visible:outline-2",
	"focus-visible:outline-(--primary-a8)",

	// Select
	"select-none",

	// Hover
	"hover:bg-(--base-a3)",
	"hover:text-(--base-a12)",

	// Active
	"active:bg-(--base-a4)",
	"data-[status=active]:bg-(--base-a4)",
	"data-[status=active]:inset-ring",
	"data-[status=active]:inset-ring-(--base-a7)",
	"data-[status=active]:text-(--base-a12)",
])
